import React from 'react'
import PropTypes from 'prop-types'

function ChatParticipantsList({participants}) {
  const participantItem = participant => (
    <div className="participant-item" key={`participant_${participant.id}`}>
      {participant.displayName}
    </div>
  )

  return <div className="chat-participants-list">{participants.map(p => participantItem(p))}</div>
}

ChatParticipantsList.propTypes = {
  participants: PropTypes.array,
}

export default ChatParticipantsList
